import React, { useState } from "react";
import netsuke_1 from "~/assets/images/netsukes/netsuke_1.png";
import netsuke_2 from "~/assets/images/netsukes/netsuke_2.png";
import netsuke_3 from "~/assets/images/netsukes/netsuke_3.png";
import netsuke_4 from "~/assets/images/netsukes/netsuke_4.png";
import netsuke_5 from "~/assets/images/netsukes/netsuke_5.png";
import netsuke_6 from "~/assets/images/netsukes/netsuke_6.png";
import netsuke_7 from "~/assets/images/netsukes/netsuke_7.png";
import netsuke_1_gif from "~/assets/videos/netsukes/netsuke_1.gif";
import netsuke_2_gif from "~/assets/videos/netsukes/netsuke_2.gif";
import netsuke_3_gif from "~/assets/videos/netsukes/netsuke_3.gif";
import netsuke_4_gif from "~/assets/videos/netsukes/netsuke_4.gif";
import netsuke_5_gif from "~/assets/videos/netsukes/netsuke_5.gif";
import netsuke_6_gif from "~/assets/videos/netsukes/netsuke_6.gif";

const images = {
  calm: netsuke_1,
  cool: netsuke_2,
  curious: netsuke_3,
  fabulous: netsuke_4,
  fire: netsuke_5,
  foxy: netsuke_6,
  sad: netsuke_7,
};

const videos = {
  calm: netsuke_1_gif,
  cool: netsuke_2_gif,
  curious: netsuke_3_gif,
  fabulous: netsuke_4_gif,
  fire: netsuke_5_gif,
  foxy: netsuke_6_gif,
};

const sizes = {
  sm: "w-24",
  base: "w-40",
  lg: "w-56",
};
const videoSizes = { sm: "w-36", base: "w-60", lg: "w-80" };

export default function Netsuke(props) {
  const { style, size = "base", className = "", animated = false } = props;

  const availableStyles = animated ? Object.keys(videos) : Object.keys(images);

  const [fallbackStyle] = useState(
    () => availableStyles[Math.floor(Math.random() * availableStyles.length)],
  );

  const selectedStyle = style || fallbackStyle;

  const src =
    animated && videos[selectedStyle]
      ? videos[selectedStyle]
      : images[selectedStyle];

  const sizeClass =
    animated && videos[selectedStyle] ? videoSizes[size] : sizes[size];

  return (
    <img
      src={src}
      alt={selectedStyle}
      className={`${sizeClass} ${className} flex-shrink-0`}
    />
  );
}
